<template>
  <div
    ref="quickView"
    class="quick-view"
    :class="{ 'quick-view--visible': isVisible }"
    :style="`height: ${quickViewHeight}px; width: ${quickViewWidth}px`"
    v-data-test-id="'quick-view'"
  >
    <transition-group name="state-change" mode="out-in" tag="div" class="quick-view__inner">
      <QuickViewOverview
        v-if="currentState === STATES.overview"
        key="overview"
        :product="product"
        :sku="skuInternal"
        @state-change="updateState"
        @update-sku="updateSku"
      />
      <QuickViewSizes
        v-if="currentState === STATES.sizes"
        key="sizes"
        :productName="product.name"
        :slug="slug"
        :variant="currentVariant"
        @state-change="updateState"
        @select-size="updateSelectedSize"
      />
      <QuickViewConfirmation
        v-if="currentState === STATES.confirmation"
        key="confirmation"
        :productName="product.name"
        :variant="currentVariant"
        :selectedSkuObj="selectedSkuObj"
      />
    </transition-group>
  </div>
</template>

<script>
import QuickViewConfirmation from './QuickViewConfirmation.vue'
import QuickViewOverview from './QuickViewOverview.vue'
import QuickViewSizes from './QuickViewSizes.vue'

export const STATES = {
  overview: 'overview',
  sizes: 'sizes',
  confirmation: 'confirmation',
}

export default {
  name: 'QuickView',
  components: { QuickViewOverview, QuickViewSizes, QuickViewConfirmation },
  props: {
    product: {
      type: Object,
      required: true,
    },
    sku: {
      type: Number,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentState: STATES.overview,
      skuInternal: this.sku,
      isVisible: false,
      quickViewHeight: '',
      quickViewWidth: '',
      selectedSkuObj: {},
      STATES,
    }
  },
  computed: {
    currentVariant() {
      return this.product.variants.find(v => Number(v.spreeProduct.sku) === this.skuInternal)
    },
  },

  mounted() {
    this.$nextTick(() => (this.isVisible = true))
    this.quickViewHeight = this.$refs.quickView.offsetHeight
    this.quickViewWidth = this.$refs.quickView.offsetWidth
  },

  methods: {
    updateState(state) {
      this.currentState = state
    },

    updateSelectedSize(selectedSkuObj) {
      this.selectedSkuObj = selectedSkuObj
    },

    updateSku(sku) {
      this.skuInternal = sku
    },
  },
}
</script>

<style lang="scss" scoped>
@import './QuickView';
</style>
